import { Link } from 'gatsby';
import DownloadsArticles from 'components/Downloads/IntroDownloads';
import NavButtons from 'components/Products/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  DownloadsArticles,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};